import imageClientAPI from 'image-client-api/dist/imageClientSDK';
import { GalleryOptions_Layout_Type } from 'ricos-schema';

const WIX_MEDIA_BASE_URL = "https://static.wixstatic.com/";
const WIX_VIDEO_BASE_URL = "https://video.wixstatic.com/";
const getWixFilename = (url) => url.replace(WIX_MEDIA_BASE_URL, "");
const isAbsoluteUrl = (url) => url.startsWith("http://") || url.startsWith("https://");
const getAbsoluteUrl = (url, type) => {
  if (isAbsoluteUrl(url)) {
    return url;
  }
  let baseUrl, baseFolder;
  if (type === "image") {
    baseUrl = WIX_MEDIA_BASE_URL;
    baseFolder = "media/";
  } else {
    baseUrl = WIX_VIDEO_BASE_URL;
    baseFolder = "video/";
  }
  const pathWithFolder = url.startsWith(baseFolder) ? url : baseFolder + url;
  return baseUrl + pathWithFolder;
};

const layoutData = {
  [GalleryOptions_Layout_Type.COLLAGE]: {
    isVertical: true,
    oneRow: false,
    galleryType: "Columns",
    gallerySizePx: "300"
  },
  [GalleryOptions_Layout_Type.MASONRY]: {
    numberOfImagesPerRow: 0,
    isVertical: false,
    gallerySizePx: "300"
  },
  [GalleryOptions_Layout_Type.GRID]: {
    numberOfImagesPerRow: 3,
    cubeType: "fill",
    cubeRatio: 1,
    isVertical: true,
    oneRow: false
  },
  [GalleryOptions_Layout_Type.THUMBNAIL]: {
    galleryThumbnailsAlignment: "bottom",
    thumbnailSpacings: 5
  },
  [GalleryOptions_Layout_Type.SLIDER]: {
    cubeType: "fit",
    cubeRatio: "16/9"
  },
  [GalleryOptions_Layout_Type.SLIDESHOW]: {
    cubeType: "fit"
  },
  [GalleryOptions_Layout_Type.PANORAMA]: {
    hasThumbnails: false,
    galleryThumbnailsAlignment: "none"
  },
  [GalleryOptions_Layout_Type.COLUMN]: {
    hasThumbnails: false,
    galleryThumbnailsAlignment: "none"
  },
  [GalleryOptions_Layout_Type.FULLSIZE]: {
    cubeType: "fill"
  }
};
({
  [GalleryOptions_Layout_Type.COLLAGE]: {
    layout: {
      type: "COLLAGE",
      orientation: "COLUMNS",
      horizontalScroll: false
    },
    item: {
      crop: "FILL",
      targetSize: 300
    },
    thumbnails: {
      placement: "NONE"
    }
  },
  [GalleryOptions_Layout_Type.MASONRY]: {
    layout: {
      type: "MASONRY",
      orientation: "ROWS",
      numberOfColumns: 0
    },
    item: {
      crop: "FILL",
      targetSize: 300
    },
    thumbnails: {
      placement: "NONE"
    }
  },
  [GalleryOptions_Layout_Type.GRID]: {
    layout: {
      type: "GRID",
      orientation: "COLUMNS",
      horizontalScroll: false,
      numberOfColumns: 3
    },
    item: {
      crop: "FILL",
      ratio: 1
    },
    thumbnails: {
      placement: "NONE"
    }
  },
  [GalleryOptions_Layout_Type.THUMBNAIL]: {
    layout: {
      type: "THUMBNAIL",
      orientation: "ROWS"
    },
    item: {
      crop: "FILL"
    },
    thumbnails: {
      placement: "BOTTOM",
      spacing: 5
    }
  },
  [GalleryOptions_Layout_Type.SLIDER]: {
    layout: {
      type: "SLIDER",
      orientation: "ROWS"
    },
    item: {
      crop: "FIT",
      ratio: 16 / 9
    },
    thumbnails: {
      placement: "NONE"
    }
  },
  [GalleryOptions_Layout_Type.SLIDESHOW]: {
    layout: {
      type: "SLIDESHOW",
      orientation: "ROWS"
    },
    item: {
      crop: "FILL"
    },
    thumbnails: {
      placement: "NONE"
    }
  },
  [GalleryOptions_Layout_Type.PANORAMA]: {
    layout: {
      type: "PANORAMA",
      orientation: "ROWS"
    },
    item: {
      crop: "FILL"
    },
    thumbnails: {
      placement: "NONE"
    }
  },
  [GalleryOptions_Layout_Type.COLUMN]: {
    layout: {
      type: "COLUMN",
      orientation: "ROWS"
    },
    item: {
      crop: "FILL"
    },
    thumbnails: {
      placement: "NONE"
    }
  },
  [GalleryOptions_Layout_Type.FULLSIZE]: {
    layout: {
      type: "FULLSIZE",
      orientation: "ROWS"
    },
    item: {
      crop: "FILL"
    },
    thumbnails: {
      placement: "NONE"
    }
  }
});

var __defProp$1 = Object.defineProperty;
var __getOwnPropSymbols$1 = Object.getOwnPropertySymbols;
var __hasOwnProp$1 = Object.prototype.hasOwnProperty;
var __propIsEnum$1 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1 = (obj, key, value) => key in obj ? __defProp$1(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1.call(b, prop))
      __defNormalProp$1(a, prop, b[prop]);
  if (__getOwnPropSymbols$1)
    for (var prop of __getOwnPropSymbols$1(b)) {
      if (__propIsEnum$1.call(b, prop))
        __defNormalProp$1(a, prop, b[prop]);
    }
  return a;
};
const GALLERY_ITEMS_TYPES = Object.freeze({
  IMAGE: "image",
  VIDEO: "video"
});
Object.freeze([
  GalleryOptions_Layout_Type.THUMBNAIL,
  GalleryOptions_Layout_Type.SLIDER,
  GalleryOptions_Layout_Type.SLIDESHOW,
  GalleryOptions_Layout_Type.COLUMN,
  GalleryOptions_Layout_Type.FULLSIZE
]);
Object.freeze({
  items: [],
  styles: __spreadValues$1({
    galleryLayout: 2
  }, layoutData[GalleryOptions_Layout_Type.GRID]),
  config: {
    alignment: "center",
    size: "content"
  }
});
({
  [GalleryOptions_Layout_Type.COLLAGE]: {
    galleryType: "Columns",
    imageMargin: 5
  },
  [GalleryOptions_Layout_Type.MASONRY]: {
    imageMargin: 5,
    isVertical: false,
    gridStyle: 0
  },
  [GalleryOptions_Layout_Type.GRID]: {
    imageResize: false,
    gridStyle: 1,
    galleryImageRatio: 2,
    imageMargin: 5
  },
  [GalleryOptions_Layout_Type.THUMBNAIL]: {
    arrowsSize: 23,
    thumbnailSize: 120,
    floatingImages: 0
  },
  [GalleryOptions_Layout_Type.SLIDER]: {
    arrowsSize: 23,
    imageMargin: 5
  },
  [GalleryOptions_Layout_Type.SLIDESHOW]: {
    arrowsSize: 23,
    floatingImages: 0,
    slideshowInfoSize: 0
  },
  [GalleryOptions_Layout_Type.PANORAMA]: {
    hasThumbnails: false,
    imageMargin: 5
  },
  [GalleryOptions_Layout_Type.COLUMN]: {
    arrowsSize: 23,
    hasThumbnails: false,
    imageMargin: 5
  },
  [GalleryOptions_Layout_Type.FULLSIZE]: {
    arrowsSize: 23,
    floatingImages: 0,
    slideshowInfoSize: 0
  }
});
({
  0: GalleryOptions_Layout_Type.COLLAGE,
  1: GalleryOptions_Layout_Type.MASONRY,
  2: GalleryOptions_Layout_Type.GRID,
  3: GalleryOptions_Layout_Type.THUMBNAIL,
  4: GalleryOptions_Layout_Type.SLIDER,
  5: GalleryOptions_Layout_Type.SLIDESHOW,
  6: GalleryOptions_Layout_Type.PANORAMA,
  7: GalleryOptions_Layout_Type.COLUMN,
  8: GalleryOptions_Layout_Type.MAGIC,
  9: GalleryOptions_Layout_Type.FULLSIZE
});

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const getResizedImageUrl = (item, originalUrl, resizeMethod, requiredWidth, requiredHeight, sharpParams, focalPoint) => {
  originalUrl = originalUrl || "";
  sharpParams = sharpParams || {};
  if (sharpParams.quality > 0) {
    sharpParams.quality = Math.min(90, sharpParams.quality);
  }
  const focalPointObj = { x: 50, y: 50 };
  if (focalPoint && focalPoint[0] >= 0 && focalPoint[1] >= 0) {
    focalPointObj.x = Math.round(focalPoint[0] * 100);
    focalPointObj.y = Math.round(focalPoint[1] * 100);
  }
  if (sharpParams.allowUsm === true && sharpParams.usm) {
    sharpParams.usm.usm_a = Math.min(5, Math.max(0, sharpParams.usm.usm_a || 0));
    sharpParams.usm.usm_r = Math.min(128, Math.max(0, sharpParams.usm.usm_r || 0));
    sharpParams.usm.usm_t = Math.min(1, Math.max(0, sharpParams.usm.usm_t || 0));
  } else {
    sharpParams.usm = {
      usm_a: 0,
      usm_r: 0,
      usm_t: 0
    };
  }
  let resizer = () => {
  };
  if (resizeMethod === "fit") {
    resizer = imageClientAPI.getScaleToFitImageURL;
  } else {
    resizer = imageClientAPI.getScaleToFillImageURL;
  }
  const options = {};
  if (sharpParams.quality > 0) {
    options.quality = sharpParams.quality;
  }
  if (sharpParams.blur > 0) {
    options.filters = {
      blur: sharpParams.blur
    };
  }
  if (focalPointObj) {
    options.focalPoint = focalPointObj;
  }
  if (sharpParams && sharpParams.usm) {
    options.unsharpMask = {
      radius: parseFloat(sharpParams.usm.usm_r),
      amount: parseFloat(sharpParams.usm.usm_a),
      threshold: parseFloat(sharpParams.usm.usm_t)
    };
  }
  if (isAbsoluteUrl(originalUrl)) {
    return originalUrl;
  }
  return resizer(
    getWixFilename(originalUrl),
    item.maxWidth,
    item.maxHeight,
    requiredWidth,
    requiredHeight,
    options
  );
};
const fullscreenResizeMediaUrl = (params) => resizeMediaUrl(__spreadProps(__spreadValues({}, params), {
  requiredWidth: params.requiredWidth * 2,
  requiredHeight: params.requiredHeight * 2
}));
const resizeMediaUrl = ({
  item,
  originalUrl,
  resizeMethod,
  requiredWidth,
  requiredHeight,
  sharpParams,
  focalPoint
}) => {
  originalUrl = originalUrl || "";
  sharpParams = sharpParams || {};
  if (originalUrl.indexOf("base64") !== -1) {
    return originalUrl;
  }
  requiredWidth = Math.ceil(requiredWidth);
  requiredHeight = Math.ceil(requiredHeight);
  if (resizeMethod === GALLERY_ITEMS_TYPES.VIDEO) {
    return getAbsoluteUrl(originalUrl, GALLERY_ITEMS_TYPES.VIDEO);
  } else if (requiredWidth >= item.maxWidth && requiredHeight >= item.maxHeight) {
    const url = item.dto.metaData.type === GALLERY_ITEMS_TYPES.VIDEO ? originalUrl : item.url;
    return getAbsoluteUrl(url, GALLERY_ITEMS_TYPES.IMAGE);
  } else {
    return getResizedImageUrl(
      item,
      originalUrl,
      resizeMethod,
      requiredWidth,
      requiredHeight,
      sharpParams,
      focalPoint
    );
  }
};

export { fullscreenResizeMediaUrl, resizeMediaUrl };
